<form [formGroup] = "form">
    <div class = "ui-field-group">
        <div class = "ui-field">
            <div class = "ui-field-label">Peso(g)</div>
            <input type = "text" placeholder = "100" formControlName = "weight">
        </div>
        <div class = "ui-field">
            <div class = "ui-field-label">Altura(cm)</div>
            <input type = "text" placeholder = "30" formControlName = "height">
        </div>
        <div class = "ui-field">
            <div class = "ui-field-label">Largura(cm)</div>
            <input type = "text" placeholder = "30" formControlName = "width">
        </div>
        <div class = "ui-field">
            <div class = "ui-field-label">Comprimento(cm)</div>
            <input type = "text" placeholder = "30" formControlName = "length">
        </div>
    </div>
</form>
